import * as events from '../../hooks/useTracking/events/index.js';
import { EVENT_CLICK, EVENT_LOAD, EVENT_PAGE_LOAD, EVENT_PAGE_VIEW, EVENT_TOOLTIP } from '../../hooks/useTracking/events/eventTypes.js';
export const eventsMap = {
  [EVENT_PAGE_LOAD]: events.pageLoadEvent.handler,
  [EVENT_PAGE_VIEW]: events.pageViewEvent.handler,
  [EVENT_CLICK]: events.clickEvent.handler,
  [EVENT_LOAD]: events.loadEvent.handler,
  [EVENT_TOOLTIP]: events.tooltipEvent.handler
};